(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-listing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.blog-listing').forEach(function(bl) {
  var filterBtns = bl.querySelectorAll('.blog-listing__filter-btn');
  var groups = bl.querySelectorAll('.blog-listing__group');

  function applyFilter(filter) {
    groups.forEach(function(group) {
      var cards = group.querySelectorAll('.blog-listing__card');
      if (filter === 'all') {
        group.hidden = false;
        cards.forEach(function(card, i) { card.hidden = i >= 3; });
      } else {
        var match = group.dataset.tag === filter;
        group.hidden = !match;
        if (match) {
          cards.forEach(function(card) { card.hidden = false; });
        }
      }
    });
  }

  applyFilter('all');

  filterBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      filterBtns.forEach(function(b) {
        b.classList.remove('blog-listing__filter-btn--active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('blog-listing__filter-btn--active');
      btn.setAttribute('aria-selected', 'true');
      applyFilter(btn.dataset.filter);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-post-with-sidebar"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__cartBtnInit) return;
  window.__cartBtnInit = true;

  document.addEventListener('click', function (e) {
    var variantBtn = e.target.closest('.variant-btn');
    if (variantBtn) {
      var card = variantBtn.closest('.cs-product');
      if (!card) return;
      card.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('active'); });
      variantBtn.classList.add('active');
      var img = card.querySelector('.main-image');
      if (img && variantBtn.dataset.image) img.src = variantBtn.dataset.image;
      var priceEl = card.querySelector('.pp-prices .price');
      if (priceEl && variantBtn.dataset.price) priceEl.textContent = variantBtn.dataset.price;
      var compareEl = card.querySelector('.compare-price s');
      if (compareEl && variantBtn.dataset.compare) compareEl.textContent = variantBtn.dataset.compare;
      var addBtn = card.querySelector('.add-to-cart-btn');
      if (addBtn && variantBtn.dataset.id) addBtn.dataset.variantId = variantBtn.dataset.id;
      var pricesWrapper = card.querySelector('.pp-prices');
      if (pricesWrapper) {
        pricesWrapper.classList.toggle('compare-available', !!(variantBtn.dataset.compare && variantBtn.dataset.compare !== variantBtn.dataset.price));
      }
      return;
    }

    var addBtn = e.target.closest('.add-to-cart-btn');
    if (!addBtn || addBtn.disabled) return;
    var variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    addBtn.disabled = true;
    addBtn.classList.add('rik-atc--loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, data: { itemCount: cart.item_count, source: 'new-product-card' } },
        }));
        var cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
        addBtn.classList.add('rik-atc--added');
        setTimeout(function () { addBtn.classList.remove('rik-atc--added'); }, 1500);
      })
      .catch(function (err) { console.error('Add to cart failed:', err); })
      .finally(function () {
        addBtn.disabled = false;
        addBtn.classList.remove('rik-atc--loading');
      });
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

document.addEventListener('click', function (e) {
    // --- Variant button ---
    const variantBtn = e.target.closest('.variant-btn');
    if (variantBtn) {
      const card = variantBtn.closest('.cs-product');
      if (!card) return;

      card.querySelectorAll('.variant-btn').forEach(function (btn) {
        btn.classList.remove('active');
      });
      variantBtn.classList.add('active');

      const img = card.querySelector('.main-image');
      if (img && variantBtn.dataset.image) img.src = variantBtn.dataset.image;

      const priceEl = card.querySelector('.pp-prices .price');
      if (priceEl && variantBtn.dataset.price) priceEl.textContent = variantBtn.dataset.price;

      const compareEl = card.querySelector('.compare-price s');
      if (compareEl && variantBtn.dataset.compare) compareEl.textContent = variantBtn.dataset.compare;

      const addBtn = card.querySelector('.add-to-cart-btn');
      if (addBtn && variantBtn.dataset.id) addBtn.dataset.variantId = variantBtn.dataset.id;

      // Toggle compare-available class based on whether compare price exists
      const pricesWrapper = card.querySelector('.pp-prices');
      if (pricesWrapper) {
        pricesWrapper.classList.toggle(
          'compare-available',
          !!(variantBtn.dataset.compare && variantBtn.dataset.compare !== variantBtn.dataset.price)
        );
      }

      return;
    }

    // --- Add to cart button ---
    const addBtn = e.target.closest('.add-to-cart-btn');
    if (!addBtn) return;
    if (addBtn.disabled) return;

    const variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    addBtn.disabled = true;
    addBtn.classList.add('rik-atc--loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        // Notify the theme's cart icon
        var cartEvent = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            data: { itemCount: cart.item_count, source: 'new-product-card' },
          },
        });
        document.dispatchEvent(cartEvent);

        // Open cart drawer directly (works regardless of the auto-open theme setting)
        var cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }

        addBtn.classList.add('rik-atc--added');
        setTimeout(function () { addBtn.classList.remove('rik-atc--added'); }, 1500);
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
      })
      .finally(function () {
        addBtn.disabled = false;
        addBtn.classList.remove('rik-atc--loading');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-collection-banner-usp-shoppable-biyu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBanner = (section) => {
      if (section.dataset.mcBannerInitialized === 'true') return;
      section.dataset.mcBannerInitialized = 'true';

      const tooltipTriggers = [...section.querySelectorAll('[data-mc-tooltip-trigger]')];
      const closeAllTooltips = (except) => {
        tooltipTriggers.forEach((trigger) => {
          if (trigger === except) return;
          trigger.setAttribute('aria-expanded', 'false');
          const card = section.querySelector(`#${trigger.getAttribute('aria-controls')}`);
          if (card) card.hidden = true;
        });
      };

      tooltipTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const card = section.querySelector(`#${trigger.getAttribute('aria-controls')}`);
          if (!card) return;
          const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
          closeAllTooltips(trigger);
          trigger.setAttribute('aria-expanded', String(willOpen));
          card.hidden = !willOpen;
        });
      });

      document.addEventListener('click', (event) => {
        if (!section.contains(event.target)) closeAllTooltips();
      });

      section.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closeAllTooltips();
      });

      const carousel = section.querySelector('[data-mc-usp-carousel]');
      const track = section.querySelector('[data-mc-usp-track]');
      if (!carousel || !track || track.children.length < 3) return;

      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const originalSlideCount = track.children.length - 1;
      let currentIndex = 0;
      let autoplay;
      let touchStartX = 0;

      const slideWidth = () => track.firstElementChild.getBoundingClientRect().width;
      const setPosition = (withoutTransition = false) => {
        if (withoutTransition) track.style.transition = 'none';
        track.style.transform = `translate3d(-${currentIndex * slideWidth()}px, 0, 0)`;
        if (withoutTransition) requestAnimationFrame(() => (track.style.transition = ''));
      };

      const move = (direction = 1) => {
        if (!mobileQuery.matches) return;
        currentIndex += direction;
        if (currentIndex < 0) {
          currentIndex = originalSlideCount - 1;
          setPosition(true);
          requestAnimationFrame(() => {
            currentIndex -= 1;
            setPosition();
          });
          return;
        }
        setPosition();
        if (currentIndex === originalSlideCount) {
          window.setTimeout(() => {
            currentIndex = 0;
            setPosition(true);
          }, 360);
        }
      };

      const stopAutoplay = () => window.clearInterval(autoplay);
      const startAutoplay = () => {
        stopAutoplay();
        if (!mobileQuery.matches || reducedMotionQuery.matches || document.hidden) return;
        autoplay = window.setInterval(() => move(), 5000);
      };

      carousel.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0].clientX;
        stopAutoplay();
      }, { passive: true });
      carousel.addEventListener('touchend', (event) => {
        const delta = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 32) move(delta < 0 ? 1 : -1);
        startAutoplay();
      }, { passive: true });
      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      window.addEventListener('resize', () => setPosition(true));
      document.addEventListener('visibilitychange', startAutoplay);
      mobileQuery.addEventListener('change', () => {
        currentIndex = 0;
        setPosition(true);
        startAutoplay();
      });

      setPosition(true);
      startAutoplay();
    };

    document.querySelectorAll('[data-mc-collection-banner]').forEach(initBanner);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-mc-collection-banner]');
      if (section) initBanner(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verkooppunten"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var leafletLoading = null;

    function loadLeaflet() {
      if (window.L) return Promise.resolve(window.L);
      if (leafletLoading) return leafletLoading;
      leafletLoading = new Promise(function (resolve, reject) {
        if (!document.querySelector('link[data-vp-leaflet]')) {
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
          link.setAttribute('data-vp-leaflet', '');
          document.head.appendChild(link);
        }
        var script = document.createElement('script');
        script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
        script.async = true;
        script.onload = function () { resolve(window.L); };
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return leafletLoading;
    }

    function distanceKm(aLat, aLng, bLat, bLng) {
      var r = 6371;
      var dLat = (bLat - aLat) * Math.PI / 180;
      var dLng = (bLng - aLng) * Math.PI / 180;
      var h = Math.sin(dLat / 2) * Math.sin(dLat / 2)
        + Math.cos(aLat * Math.PI / 180) * Math.cos(bLat * Math.PI / 180)
        * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * r * Math.asin(Math.min(1, Math.sqrt(h)));
    }

    function formatKm(km) {
      if (km < 1) return Math.round(km * 1000) + ' m';
      return km.toFixed(1).replace('.', ',') + ' km';
    }

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (char) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
      });
    }

    function initLocator(root) {
      if (!root || root.getAttribute('data-vp-ready') === 'true') return;
      root.setAttribute('data-vp-ready', 'true');

      var mapEl = root.querySelector('[data-vp-map]');
      var list = root.querySelector('[data-vp-list]');
      var search = root.querySelector('[data-vp-search]');
      var near = root.querySelector('[data-vp-near]');
      var countEl = root.querySelector('[data-vp-count]');
      var statusEl = root.querySelector('[data-vp-status]');
      var emptyEl = root.querySelector('[data-vp-empty]');
      var noneEl = root.querySelector('[data-vp-none]');
      var items = Array.prototype.slice.call(root.querySelectorAll('.vp-store'));
      var filters = Array.prototype.slice.call(root.querySelectorAll('[data-vp-filter]'));
      var activeCountry = '';
      var origin = null;
      var markers = [];
      var map = null;

      function visibleItems() {
        var query = (search && search.value || '').trim().toLowerCase();
        return items.filter(function (item) {
          var country = (item.getAttribute('data-country') || '').toLowerCase();
          var blob = (item.getAttribute('data-search') || '').toLowerCase();
          var countryOk = !activeCountry || country === activeCountry.toLowerCase();
          var queryOk = !query || blob.indexOf(query) !== -1;
          return countryOk && queryOk;
        });
      }

      function setActive(item) {
        items.forEach(function (entry) {
          entry.classList.toggle('is-active', entry === item);
        });
        markers.forEach(function (entry) {
          var active = entry.item === item;
          var el = entry.marker.getElement();
          if (el) el.classList.toggle('is-active', active);
          entry.marker.setZIndexOffset(active ? 500 : 0);
        });
      }

      function render() {
        var shown = visibleItems();
        items.forEach(function (item) {
          item.classList.toggle('is-hidden', shown.indexOf(item) === -1);
        });
        if (countEl) {
          if (items.length === 0) {
            countEl.hidden = true;
          } else {
            countEl.hidden = false;
            countEl.textContent = shown.length === 1 ? '1 verkooppunt' : shown.length + ' verkooppunten';
          }
        }
        if (emptyEl) emptyEl.hidden = items.length !== 0;
        if (noneEl) noneEl.hidden = items.length === 0 || shown.length !== 0;

        if (!map) return;
        markers.forEach(function (entry) {
          var show = shown.indexOf(entry.item) !== -1;
          if (show) {
            if (!map.hasLayer(entry.marker)) entry.marker.addTo(map);
          } else if (map.hasLayer(entry.marker)) {
            map.removeLayer(entry.marker);
          }
        });
      }

      function showNetherlands() {
        if (!map) return;
        map.fitBounds([[50.75, 3.25], [53.55, 7.22]], { padding: [20, 20], animate: false });
      }

      function sortByOrigin() {
        if (!origin) return;
        items.sort(function (a, b) {
          var aLat = parseFloat(a.getAttribute('data-lat'));
          var aLng = parseFloat(a.getAttribute('data-lng'));
          var bLat = parseFloat(b.getAttribute('data-lat'));
          var bLng = parseFloat(b.getAttribute('data-lng'));
          var aOk = !isNaN(aLat) && !isNaN(aLng);
          var bOk = !isNaN(bLat) && !isNaN(bLng);
          if (!aOk && !bOk) return 0;
          if (!aOk) return 1;
          if (!bOk) return -1;
          return distanceKm(origin.lat, origin.lng, aLat, aLng) - distanceKm(origin.lat, origin.lng, bLat, bLng);
        });
        items.forEach(function (item) {
          var lat = parseFloat(item.getAttribute('data-lat'));
          var lng = parseFloat(item.getAttribute('data-lng'));
          var label = item.querySelector('[data-vp-distance]');
          if (label) {
            if (isNaN(lat) || isNaN(lng)) {
              label.hidden = true;
            } else {
              label.hidden = false;
              label.textContent = formatKm(distanceKm(origin.lat, origin.lng, lat, lng));
            }
          }
          list.appendChild(item);
        });
      }

      items.forEach(function (item) {
        var button = item.querySelector('[data-vp-focus]');
        if (!button) return;
        button.addEventListener('click', function () {
          setActive(item);
          var match = markers.filter(function (entry) { return entry.item === item; })[0];
          if (match && map) {
            map.setView(match.marker.getLatLng(), Math.max(map.getZoom(), 13));
            match.marker.openPopup();
          }
        });
      });

      if (search) search.addEventListener('input', render);

      filters.forEach(function (filter) {
        filter.addEventListener('click', function () {
          activeCountry = filter.getAttribute('data-vp-filter') || '';
          filters.forEach(function (entry) {
            entry.classList.toggle('is-active', entry === filter);
          });
          render();
        });
      });

      if (near) {
        near.addEventListener('click', function () {
          if (!navigator.geolocation) {
            statusEl.hidden = false;
            statusEl.textContent = 'Locatie is niet beschikbaar in deze browser.';
            return;
          }
          statusEl.hidden = false;
          statusEl.textContent = 'Locatie ophalen…';
          navigator.geolocation.getCurrentPosition(function (position) {
            origin = { lat: position.coords.latitude, lng: position.coords.longitude };
            near.classList.add('is-active');
            statusEl.hidden = true;
            sortByOrigin();
            render();
          }, function () {
            statusEl.hidden = false;
            statusEl.textContent = 'Locatie kon niet worden opgehaald.';
          });
        });
      }

      render();

      if (!mapEl) return;
      loadLeaflet().then(function (L) {
        if (!root.isConnected) return;
        map = L.map(mapEl, { scrollWheelZoom: false }).setView([52.15, 5.3], 7);
        var tileOpts = { maxZoom: 16 };
        L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', Object.assign({
          attribution: 'Tiles &copy; Esri'
        }, tileOpts)).addTo(map);
        L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}', tileOpts).addTo(map);

        var icon = L.divIcon({
          className: 'vp-pin',
          html: '<span></span>',
          iconSize: [18, 18],
          iconAnchor: [9, 9],
          popupAnchor: [0, -10]
        });

        items.forEach(function (item) {
          var lat = parseFloat(item.getAttribute('data-lat'));
          var lng = parseFloat(item.getAttribute('data-lng'));
          if (isNaN(lat) || isNaN(lng)) return;
          var marker = L.marker([lat, lng], { icon: icon }).addTo(map);
          marker.bindPopup('<strong>' + escapeHtml(item.getAttribute('data-name')) + '</strong>');
          marker.on('click', function () {
            setActive(item);
            item.scrollIntoView({ block: 'nearest' });
          });
          markers.push({ item: item, marker: marker });
        });

        mapEl._vpMap = map;
        render();
        showNetherlands();
        setTimeout(function () {
          map.invalidateSize();
          showNetherlands();
        }, 80);
      }).catch(function () {});
    }

    function boot(scope) {
      var context = scope && scope.querySelectorAll ? scope : document;
      context.querySelectorAll('[data-vp-locator]').forEach(initLocator);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      var mapEl = event.target.querySelector('[data-vp-map]');
      if (mapEl && mapEl._vpMap) mapEl._vpMap.remove();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
